export default __webpack_public_path__ + "static/media/media-step.372a60db.svg";